import * as emoji from "node-emoji";
// style
import "./styles/Emoji.scss";

interface IProps {
    el: string;
}
const Emoji = ({ el }: IProps) => {
    return (
        <div className="emoji" aria-label={el}>
            {emoji.get(el)}
        </div>
    );
};

export default Emoji;
